<section class="vs-error-wrapper space-md-top space-bottom">
    <div class="container">
        <div class="error-content text-center">
            <h1 class="error-number">404</h1>
            <h2 class="error-title h3 fw-semibold text-uppercase text-body mb-5 pb-1">The page you've requested is not available.</h2>
            <a routerLink="/home" class="vs-btn">Return To Home</a>
        </div>
    </div>
</section>
